import { FC } from 'react'
import { CustomTag } from 'src/components'
import { Withdrawal } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { getWithdrawalStatusTags } from 'src/core/helpers'

interface WithdrawalStatusColumnProps { withdrawal: Withdrawal }

const WithdrawalStatusColumn: FC<WithdrawalStatusColumnProps> = ({ withdrawal }) => {
  const { t } = useTranslation()
  const status = getWithdrawalStatusTags(t, withdrawal)

  return <div className='centered'>
    <CustomTag text={status.label} type={status.type} />
  </div>
}

export default WithdrawalStatusColumn
